import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useAuditLog } from '@/entities/admin/api/hooks';
import { antTablePagination, antTableScroll } from '@/shared/constants/antTable';
import type { AuditLogEntry } from '@/entities/admin/model/adminSchema';
import s from './AuditLogCard.module.scss';

export function AuditLogCard() {
  const { data: audit, isLoading: auditLoading } = useAuditLog();

  const auditColumns: ColumnsType<AuditLogEntry> = [
    { title: 'Дата и время', dataIndex: 'datetime', key: 'dt' },
    { title: 'Пользователь', dataIndex: 'user', key: 'user' },
    { title: 'Действие', dataIndex: 'action', key: 'action' },
  ];

  return (
    <div className={s['root__section']}>
      <div className={s['root__table-title']}>Журнал безопасности</div>
      <Table
        loading={auditLoading}
        dataSource={audit}
        columns={auditColumns}
        rowKey="id"
        size="small"
        pagination={{ ...antTablePagination }}
        scroll={antTableScroll}
      />
    </div>
  );
}
